import { Typography } from '@gurupay/gp-ui-library';
import clsx from 'clsx';
import type { FC } from 'react';

interface Option {
	label: string;
	value: string;
}

interface SwitcherProps {
	options: Option[];
	value: string;
	onChange: (value: string) => void;
	label?: string;
	className?: string;
	disabled?: boolean;
	buttonClassName?: string;
	optionsClassName?: string;
}

export const Switcher: FC<SwitcherProps> = ({
	options,
	value,
	onChange,
	label,
	className,
	disabled,
	optionsClassName,
	buttonClassName,
}) => (
	<div className={className}>
		{!!label && (
			<Typography className="mb-space-16" level="h3">
				{label}
			</Typography>
		)}
		<div
			aria-label={label || 'Option selector'}
			className={clsx(
				'inline-flex rounded-full bg-neutral-50 p-space-4 gap-space-4',
				optionsClassName,
			)}
			role="tablist"
		>
			{options.map((option) => {
				const isActive = value === option.value;
				return (
					<button
						key={option.value}
						aria-selected={isActive}
						className={clsx(
							'min-w-[130px] py-space-4 px-space-16 rounded-full text-sm-medium transition-colors duration-300 shadow-none',
							isActive
								? 'bg-white text-neutral-950'
								: 'hover:bg-neutral-100 text-neutral-950 cursor-pointer',
							disabled && 'opacity-50 cursor-not-allowed pointer-events-none',
							buttonClassName,
						)}
						disabled={disabled}
						onClick={() => onChange(option.value)}
						role="tab"
						tabIndex={0}
						type="button"
					>
						{option.label}
					</button>
				);
			})}
		</div>
	</div>
);
